const PrivacyScreen = () => {
    return (
        <div>
            Privacy Policy
        </div>
    )
};
export default PrivacyScreen;